import Item from '../Item';

export default class TopShelf extends Item {
  getHitArea() {
    const { scaledVertices } = this.data;
    const padding = 10;

    const vertices = [
      scaledVertices[0],
      scaledVertices[3],
      scaledVertices[7],
      [scaledVertices[7][0], scaledVertices[7][1] - padding],
      [scaledVertices[6][0], scaledVertices[6][1] - padding],
      scaledVertices[5],
      scaledVertices[1],
    ];

    const polygon = {
      regions: [vertices],
    };

    return {
      polygon,
    };
  }
}
